export default {
  header: {
    logout: 'Sair',
    myAccount: 'Minha conta',
    myProfile: 'Meu perfil'
  }
}
